"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68],{

/***/ 68:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LocationsPreview": function() { return /* binding */ LocationsPreview; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 105 modules
var swiper_react = __webpack_require__(56);
// EXTERNAL MODULE: ./src/components/utils/useIsSmallerThan.ts
var useIsSmallerThan = __webpack_require__(294);
// EXTERNAL MODULE: ./src/components/utils/useDetectUserTouch.ts
var useDetectUserTouch = __webpack_require__(3571);
// EXTERNAL MODULE: ./public/icons/small/Arrow-Thin-Left.svg
var Arrow_Thin_Left = __webpack_require__(3549);
// EXTERNAL MODULE: ./public/icons/small/Arrow-Thin-Right.svg
var Arrow_Thin_Right = __webpack_require__(9813);
// EXTERNAL MODULE: ./src/components/modules/Intro/Intro.tsx + 1 modules
var Intro = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@react-aria/visually-hidden/dist/module.js
var dist_module = __webpack_require__(4140);
// EXTERNAL MODULE: ./public/icons/small/Arrow-2-Right.svg
var Arrow_2_Right = __webpack_require__(6006);
// EXTERNAL MODULE: ./src/lib/storyblok/types.ts
var types = __webpack_require__(6943);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./src/components/elements/Headline/Headline.tsx
var Headline = __webpack_require__(6745);
// EXTERNAL MODULE: ./src/components/elements/Copy/Copy.tsx
var Copy = __webpack_require__(8765);
// EXTERNAL MODULE: ./src/components/utils/fullsizePseudo.ts
var fullsizePseudo = __webpack_require__(3076);
// EXTERNAL MODULE: ./src/components/utils/focusStyle.ts
var focusStyle = __webpack_require__(1586);
;// CONCATENATED MODULE: ./src/components/modules/LocationTeaser/LocationTeaser.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: var(--distance-static-s) 0 0;\n  color: currentColor;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: flex-start;\n  color: var(--color-text-dark-subdued);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: currentColor;\n\n  @media (hover: hover) {\n    &:hover {\n      color: currentColor;\n    }\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: var(--distance-static-m);\n  height: 100%;\n  background-color: var(--color-surface-light);\n  box-shadow: var(--shadow-xs);\n  border-radius: var(--border-radius-s);\n  color: var(--color-link-pimary);\n  box-sizing: border-box;\n\n  @media (hover: hover) {\n    &:hover {\n      outline: var(--distance-static-xxs) solid var(--color-surface-light);\n      box-shadow: var(--shadow-m);\n      border-radius: 0;\n      color: var(--color-link-pimary-hover);\n    }\n  }\n\n  ",
        ";\n\n  &:active {\n    outline: var(--distance-static-xxs) solid var(--color-separator-light);\n    background-color: var(--color-surface-light-subdued);\n    box-shadow: var(--shadow-xs);\n    border-radius: 0;\n    color: var(--color-link-pimary-active);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  flex-grow: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Headline/* Headline */.s).withConfig({
    componentId: "sc-ba1e5bae-0"
})(_templateObject());
var StyledCopy = (0,styled_components_browser_esm/* default */.ZP)(Copy/* Copy */.CK).withConfig({
    componentId: "sc-ba1e5bae-1"
})(_templateObject1());
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ba1e5bae-2"
})(_templateObject2(), fullsizePseudo/* fullsizePseudo */.l);
var StyledTeaser = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-ba1e5bae-3"
})(_templateObject3(), focusStyle/* focusWithinStyleDark */.PQ);
var StyledRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba1e5bae-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/components/modules/LocationTeaser/LocationTeaser.tsx







var LocationTeaser = function(param) {
    var className = param.className, headline = param.headline, subtitle = param.subtitle, image = param.image, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeaser, {
        className: className,
        children: [
            image,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                size: "h5",
                forwardedAs: "h3",
                label: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCopy, {
                        size: "s",
                        text: subtitle
                    }),
                    link.linkType === types/* linkTypes.internal */.e.internal ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: link.href,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* VisuallyHidden */.T, {
                                    children: link.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow_2_Right/* default */.Z, {})
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                        href: link.href,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* VisuallyHidden */.T, {
                                children: link.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow_2_Right/* default */.Z, {})
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/elements/IconButton/IconButton.tsx
var IconButton = __webpack_require__(5556);
// EXTERNAL MODULE: ./src/components/utils/mediaQueries.ts
var mediaQueries = __webpack_require__(5672);
// EXTERNAL MODULE: ./src/components/modules/Wrapper/Wrapper.tsx + 1 modules
var Wrapper = __webpack_require__(8709);
;// CONCATENATED MODULE: ./src/components/modules/LocationsPreview/LocationsPreview.styled.ts

function LocationsPreview_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    LocationsPreview_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocationsPreview_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 0;\n"
    ]);
    LocationsPreview_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocationsPreview_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: var(--distance-static-l);\n\n  ",
        ";\n"
    ]);
    LocationsPreview_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocationsPreview_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: var(--distance-dynamic-xl);\n\n  @media screen and (",
        ") {\n    padding-left: var(--distance-static-xxl);\n  }\n\n  @media screen and (",
        ") {\n    padding-left: 0;\n  }\n"
    ]);
    LocationsPreview_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocationsPreview_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > ul {\n    display: flex;\n    box-sizing: border-box;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n"
    ]);
    LocationsPreview_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: var(\n    --distance-static-3xs\n  ); // to show teaser box shadow in overflow context from the slider\n  height: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: var(--zindex-m);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: var(--page-spacing-dynamic);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: var(--page-spacing-dynamic);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var StyledLocationTeaser = (0,styled_components_browser_esm/* default */.ZP)(LocationTeaser).withConfig({
    componentId: "sc-e0b5cb9e-0"
})(LocationsPreview_styled_templateObject());
var handleGrid = function(items) {
    switch(items){
        case 2:
            return "grid-template-columns: repeat(".concat(items, ", 1fr);");
        case 3:
            return "grid-template-columns: repeat(".concat(items, ", 1fr);");
        case 4:
            return "grid-template-columns: repeat(2, 1fr);";
        case 5:
            return '\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n        grid-template-rows: 1fr 0.5fr;\n        grid-template-areas:\n          "first first first second second second"\n          "third third fourth fourth fifth fifth";\n\n        '.concat(StyledLocationTeaser, ":first-of-type {\n          grid-area: first;\n        }\n\n        ").concat(StyledLocationTeaser, ":nth-child(2) {\n          grid-area: second;\n        }\n\n        ").concat(StyledLocationTeaser, ":nth-child(3) {\n          grid-area: third;\n        }\n\n        ").concat(StyledLocationTeaser, ":nth-child(4) {\n          grid-area: fourth;\n        }\n\n        ").concat(StyledLocationTeaser, ":last-child {\n          grid-area: fifth;\n        }\n      ");
        case 6:
            return "grid-template-columns: repeat(3, 1fr);";
    }
};
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper.Wrapper).withConfig({
    componentId: "sc-e0b5cb9e-1"
})(LocationsPreview_styled_templateObject1());
var StyledGrid = (0,styled_components_browser_esm/* default */.ZP)(Wrapper.Wrapper).withConfig({
    componentId: "sc-e0b5cb9e-2"
})(LocationsPreview_styled_templateObject2(), function(param) {
    var $items = param.$items;
    return handleGrid($items);
});
var StyledSlider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0b5cb9e-3"
})(LocationsPreview_styled_templateObject3(), mediaQueries/* tabletPortrait */.ZI, mediaQueries/* laptop */.PJ);
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-e0b5cb9e-4"
})(LocationsPreview_styled_templateObject4());
var StyledSwiperSlide = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* SwiperSlide */.o5).withConfig({
    componentId: "sc-e0b5cb9e-5"
})(_templateObject5());
var StyledSwiperButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* IconButton */.h).withConfig({
    componentId: "sc-e0b5cb9e-6"
})(_templateObject6());
var StyledSwiperButtonPrev = (0,styled_components_browser_esm/* default */.ZP)(StyledSwiperButton).withConfig({
    componentId: "sc-e0b5cb9e-7"
})(_templateObject7());
var StyledSwiperButtonNext = (0,styled_components_browser_esm/* default */.ZP)(StyledSwiperButton).withConfig({
    componentId: "sc-e0b5cb9e-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/components/modules/LocationsPreview/LocationsPreview.tsx
// import swiper styles










var SwiperButton = function(param) {
    var direction = param.direction, label = param.label;
    var swiper = (0,swiper_react/* useSwiper */.oc)();
    var Buttons = {
        prev: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiperButtonPrev, {
            label: label,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow_Thin_Left/* default */.Z, {}),
            disabled: swiper === null || swiper === void 0 ? void 0 : swiper.isBeginning,
            onClick: function() {
                return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
            }
        }),
        next: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiperButtonNext, {
            label: label,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow_Thin_Right/* default */.Z, {}),
            disabled: swiper === null || swiper === void 0 ? void 0 : swiper.isEnd,
            onClick: function() {
                return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
            }
        })
    };
    return Buttons[direction];
};
var LocationsPreview = function(param) {
    var className = param.className, intro = param.intro, items = param.items, sliderControls = param.sliderControls;
    var ref = (0,react.useState)(0), swiperIndex = ref[0], setSwiperIndex = ref[1];
    var isSmallerThanTabletLandscape = (0,useIsSmallerThan/* useIsSmallerThan */.s)("TABLET_LANDSCAPE");
    var isSmallerThanTabletPortrait = (0,useIsSmallerThan/* useIsSmallerThan */.s)("TABLET_PORTRAIT");
    var isTouch = (0,useDetectUserTouch/* useDetectUserTouch */.S)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
                forwardedAs: "div",
                width: {
                    laptop: "m",
                    tabletLandscape: "m"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro/* Intro */.p, {
                    subtitle: intro.subtitle,
                    headline: {
                        label: intro.headline.label,
                        size: "h3",
                        as: "h2"
                    },
                    copy: intro.copy,
                    nested: true
                })
            }),
            isSmallerThanTabletLandscape ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSlider, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiper, {
                    spaceBetween: 16,
                    slidesPerView: isSmallerThanTabletPortrait ? 1.25 : 2.25,
                    onSlideChange: function(swiper) {
                        setSwiperIndex(swiper.activeIndex);
                    },
                    tag: "div",
                    wrapperTag: "ul",
                    initialSlide: 0,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                    centeredSlides: isSmallerThanTabletPortrait,
                    centeredSlidesBounds: true,
                    keyboard: true,
                    children: [
                        items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiperSlide, {
                                tag: "li",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationTeaser, {
                                    headline: item.headline,
                                    subtitle: item.subtitle,
                                    image: item.image,
                                    link: item.link
                                })
                            }, item.id);
                        }),
                        !isTouch && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperButton, {
                                    label: sliderControls === null || sliderControls === void 0 ? void 0 : sliderControls.prevLabel,
                                    direction: "prev",
                                    swiperIndex: swiperIndex
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperButton, {
                                    label: sliderControls === null || sliderControls === void 0 ? void 0 : sliderControls.nextLabel,
                                    direction: "next",
                                    swiperIndex: swiperIndex
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid, {
                forwardedAs: "div",
                width: {
                    laptop: "l",
                    tabletLandscape: "m"
                },
                $items: items.length,
                children: items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocationTeaser, {
                        headline: item.headline,
                        subtitle: item.subtitle,
                        image: item.image,
                        link: item.link
                    }, item.id);
                })
            })
        ]
    });
};


/***/ }),

/***/ 3571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useDetectUserTouch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useDetectUserTouch() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isTouch = ref[0], setIsTouch = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (false) {}
        if (window.PointerEvent && "maxTouchPoints" in navigator) {
            // if Pointer Events are supported, just check maxTouchPoints
            if (navigator.maxTouchPoints > 0) {
                setIsTouch(true);
            }
        } else {
            // no Pointer Events...
            if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
                // check for any-pointer:coarse which mostly means touchscreen
                setIsTouch(true);
            } else if (window.TouchEvent || "ontouchstart" in window) {
                // last resort - check for exposed touch events API / event handler
                setIsTouch(true);
            }
        }
    }, []);
    return isTouch;
}


/***/ })

}]);